export const textShadowStyle = (width = '2px', color = '#ffffff') =>
  `-${width} -${width} 0 ${color}, 0 -${width} 0 ${color}, ${width} -${width} 0 ${color}, ${width} 0 0 ${color}, ${width} ${width} 0 ${color}, 0 ${width} 0 ${color}, -${width} ${width} 0 ${color}, -${width} 0 0 ${color}`;
